import { render, staticRenderFns } from "./account-international-pricing.vue?vue&type=template&id=6d086a53"
import script from "./account-international-pricing.vue?vue&type=script&lang=js"
export * from "./account-international-pricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports